// removed by extract-text-webpack-plugin
module.exports = {"slider":"slider__slider___21ZNZ","nav":"slider__nav___3n2m9","nav-item":"slider__nav-item___1n1u0","nav-item-active":"slider__nav-item-active___3BBrM","nav-item-prev":"slider__nav-item-prev___jtqQc","nav-item-next":"slider__nav-item-next___2eJEn","captions":"slider__captions___1yHwx","inner":"slider__inner___O1Kj2"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Object/Slider/slider.scss
// module id = 933
// module chunks = 0